import { useParams } from 'react-router-dom';
import { useAuth } from './use-auth';

export default function useIsDefaultWorkspace() {
  const { defaultWorkspaceId } = useAuth();
  const { workspaceId } = useParams<{ workspaceId: string }>();

  if (!workspaceId) {
    return false;
  }

  return defaultWorkspaceId === parseInt(workspaceId);
}
